<template>
  <div class="registration_form">
    <el-form
      :model="query"
      ref="lefts"
      :style="{marginBottom:!operation || !isShow?'22px':'82px'}"
      :rules="rules"
      :label-width="!operation || operation &&  !isShow ?'120px':'124px'"
    >
      <el-form-item label="中文姓名" prop="name">
        <el-input v-model="query.name" :disabled="disabledNormal" placeholder="请输入中文姓名"></el-input>
      </el-form-item>
      <el-form-item label="汉语拼音" prop="nameSpell">
        <el-input placeholder="请输入汉语拼音" :disabled="disabledNormal" v-model="query.nameSpell"></el-input>
      </el-form-item>
      <el-form-item label="政治面貌" prop="political">
        <el-select
          :popper-append-to-body="false"
          :disabled="isDisabled"
          v-model="query.political"
          placeholder="请选择"
        >
          <el-option label="团员" :value="1"></el-option>
          <el-option label="党员" :value="2"></el-option>
          <el-option label="民主党派" :value="3"></el-option>
          <el-option label="群众" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="出生年月" prop="birthday">
        <el-date-picker
          :disabled="disabledNormal"
          v-model="query.birthday"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="职称" prop="positional">
        <el-select
          :popper-append-to-body="false"
          :disabled="isDisabled"
          v-model="query.positional"
          placeholder="请选择职称"
        >
          <el-option label="初级职称" :value="1"></el-option>
          <el-option label="中级职称" :value="2"></el-option>
          <el-option label="副教授（高级教练）" :value="3"></el-option>
          <el-option label="教授（国家级教练）" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学历" prop="education">
        <el-select
          :popper-append-to-body="false"
          :disabled="isDisabled"
          v-model="query.education"
          placeholder="请选择学历"
        >
          <el-option label="大专" :value="1"></el-option>
          <el-option label="本科" :value="2"></el-option>
          <el-option label="研究生" :value="3"></el-option>
          <el-option label="其他" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学位" prop="academic">
        <el-select
          :popper-append-to-body="false"
          :disabled="isDisabled"
          v-model="query.academic"
          placeholder="请选择学位"
        >
          <el-option label="学士" :value="1"></el-option>
          <el-option label="硕士" :value="2"></el-option>
          <el-option label="博士" :value="3"></el-option>
          <el-option label="其他" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="参加培训时间" prop="trainingTime">
        <el-date-picker
          :disabled="isDisabled"
          v-model="query.trainingTime"
          type="date"
          placeholder="选择日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="移动电话" prop="phone">
        <el-input :disabled="isDisabled" v-model="query.phone" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="教练员注册号">
        <el-input disabled v-model="query.registerNumber"></el-input>
      </el-form-item>
    </el-form>
    <el-form :model="query" ref="rights" :rules="rules" label-width="124px">
      <el-form-item label="民族" prop="nation">
        <el-select
          :popper-append-to-body="false"
          :disabled="disabledNormal"
          v-model="query.nation"
          filterable
          placeholder="请选择民族"
        >
          <el-option
            v-for="(item,index) in nationList"
            :key="index"
            :label="item.label"
            :value="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="性别" prop="gender">
        <el-select
          :popper-append-to-body="false"
          :disabled="disabledNormal"
          v-model="query.gender"
          placeholder="请选择性别"
        >
          <el-option label="男" :value="1"></el-option>
          <el-option label="女" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="身高" prop="height">
        <el-input :disabled="isDisabled" v-model="query.height" placeholder="请输入身高">
          <span class="unit" slot="suffix">cm</span>
        </el-input>
      </el-form-item>
      <el-form-item label="体重" prop="weight">
        <el-input :disabled="isDisabled" placeholder="请输体重" v-model="query.weight">
          <span class="unit" slot="suffix">kg</span>
        </el-input>
      </el-form-item>
      <el-form-item label="血型">
        <el-select
          :popper-append-to-body="false"
          :disabled="isDisabled"
          v-model="query.bloodType"
          clearable
          placeholder="请选择血型"
        >
          <el-option label="A型" :value="1"></el-option>
          <el-option label="B型" :value="2"></el-option>
          <el-option label="O型" :value="3"></el-option>
          <el-option label="AB型" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="鞋码" prop="shoesSize">
        <el-input :disabled="isDisabled" v-model="query.shoesSize" placeholder="请输入鞋码">
          <span class="unit" slot="suffix">码</span>
        </el-input>
      </el-form-item>
      <el-form-item label="毕业学校" prop="graduateSchool">
        <el-input :disabled="isDisabled" v-model="query.graduateSchool" placeholder="请输入毕业学校"></el-input>
      </el-form-item>
      <el-form-item label="身份证号码" prop="idCard">
        <el-input :disabled="isDisabled" v-model="query.idCard" placeholder="请输入身份证号码"></el-input>
      </el-form-item>
      <el-form-item label="首次注册项目" prop="projectFirst">
        <el-select
          :popper-append-to-body="false"
          :disabled="disabledNormal"
          v-model="query.projectFirst"
          placeholder="请选择项目"
        >
          <el-option
            v-for="(item,index) in projectList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <p style="position:absolute;top:0;right:-40px;" v-if="!isShow">
          <span style="margin:0 0 0 15px;cursor:pointer;color:#1E63B0" @click="addNewProject">添加</span>
        </p>
      </el-form-item>
      <template v-if="query.projectFirst && operation && isShow">
        <el-form-item label="注册项目" style="position:relative">
          <el-select
            :popper-append-to-body="false"
            :disabled="operation === 'watch'?true:false"
            v-model="query.projectNew"
          >
            <el-option
              v-for="(temp,num) in otherProjectList"
              :key="num"
              :disabled="temp.disabled"
              :value="temp.value"
              :label="temp.label"
            ></el-option>
          </el-select>
          <p style="position:absolute;top:0;right:-40px;" v-if="operation !== 'watch'">
            <span
              style="margin:0 0 0 15px;cursor:pointer;color:#FD6666"
              @click="removeOtherProject"
            >删除</span>
          </p>
        </el-form-item>
      </template>
      <template v-if="!operation || (operation && !isShow)">
        <el-form-item label="培训结业证书号" prop="trainingCertificate">
          <el-input
            :disabled="isDisabled"
            placeholder="请输入结业证书号"
            v-model="query.trainingCertificate"
          ></el-input>
        </el-form-item>
      </template>
    </el-form>
    <div class="user_img">
      <div class="empty">
        <img v-if="headImage" style="width:100%;height:100%" :src="headImage" alt />
        <template v-else>
          <i class="el-icon-user-solid" font-size="40px"></i>
          <p>2寸近照</p>
        </template>
      </div>
      <el-upload
        :style="{visibility:!isDisabled?'visible':'hidden'}"
        class="upload-demo"
        accept="image/jpeg, image/jpg, image/png"
        action="//up-z1.qiniup.com"
        :show-file-list="false"
        :before-upload="handleBefore"
        :on-success="uploadSuccess"
        :data="{token: uptoken}"
      >
        <el-button
          :loading="loading"
          style="color:#1E63B0;border-color:#1E63B0;margin-top:20px"
        >上传照片</el-button>
      </el-upload>
      <div class="unit" style="margin:24px 0 0 20px">
        <span>单位：</span>
        <el-input disabled v-model="query.schoolName" style="width:180px"></el-input>
      </div>
    </div>
    <el-form
      style="position:absolute;left:0;width:calc(100% - 335px)"
      :style="{bottom:!operation && !isShow?'20px':'0'}"
      :model="query"
      :rules="rules"
      :label-width="!operation || operation &&  !isShow ?'120px':'124px'"
    >
      <el-form-item
        class="address"
        :style="{width:operation?'100%':''}"
        v-if="query.projectFirst && operation && isShow"
        label="培训结业证书号"
        prop="trainingCertificate"
      >
        <el-input
          :disabled="isDisabled"
          class="address"
          placeholder="请输入结业证书号"
          v-model="query.trainingCertificate"
        ></el-input>
      </el-form-item>
      <el-form-item
        :style="{width:operation?'100%':''}"
        class="address"
        label="通讯地址"
        prop="postalAddress"
      >
        <el-input
          :disabled="isDisabled"
          class="address"
          placeholder="请输入通讯地址"
          v-model="query.postalAddress "
        ></el-input>
      </el-form-item>
    </el-form>
    <el-dialog
      width="500px"
      title="操作提示"
      center
      :close-on-click-modal="false"
      :visible.sync="tipDialogVisible"
      :modal-append-to-body="false"
      append-to-body
    >
      <div class="modal_content">
        <i class="el-icon-warning"></i>
        <section>
          <p>无法完成操作！</p>
          <p>照片大小请限制在 1 MB以内。</p>
        </section>
      </div>
      <div class="footer_modal">
        <el-button style="width:90px" type="primary" @click="closeTips">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getSession } from "@/utils/storage.js";
import registerData from "@/assets/json/register.json";
import { rule } from "@/utils/utils";
export default {
  props: {
    uptoken: {
      type: String
    },
    formInfo: {
      type: Object
    },
    operation: {
      type: String
    }
  },
  data() {
    return {
      otherProjectList: [],
      loading: false,
      files: "",
      headImage: "",
      isShow: true,
      query: {
        name: "",
        gender: "",
        nameSpell: "",
        political: "", //政治面貌
        height: "",
        birthday: "",
        projectFirst: "",
        projectNew: "",
        weight: "",
        idCard: "",
        graduateSchool: "",
        schoolName: JSON.parse(getSession("userInfo")).schoolName,
        phone: "",
        postalAddress: "",
        headImage: "", //存照
        trainingCertificate: "", //结业证书号
        registerNumber: "", //注册号
        trainingTime: "", //参加培训时间
        projectFirst: "", //注册项目
        academic: "", //学位
        shoesSize: "", //鞋码
        education: "", //学历
        bloodType: "", //血型
        positional: "", //职称
        nation: "" //民族
      },
      rules: {
        name: [{ required: true, validator: rule.name, trigger: "blur" }],
        nation: [{ required: true, validator: rule.nation, trigger: "change" }],
        nameSpell: [
          { required: true, validator: rule.nameSpell, trigger: "blur" }
        ],
        gender: [{ required: true, validator: rule.gender, trigger: "change" }],
        political: [
          { required: true, validator: rule.political, trigger: "change" }
        ],
        birthday: [
          {
            type: "date",
            required: true,
            validator: rule.birthday,
            trigger: "change"
          }
        ],
        height: [{ validator: rule.height, trigger: "blur" }],
        weight: [{ validator: rule.weight, trigger: "blur" }],
        shoesSize: [{ validator: rule.shoesSize, trigger: "blur" }],
        positional: [
          { required: true, validator: rule.positional, trigger: "change" }
        ],
        education: [
          { required: true, validator: rule.education, trigger: "change" }
        ],
        academic: [
          { required: true, validator: rule.academic, trigger: "change" }
        ],
        projectFirst: [
          { required: true, validator: rule.project, trigger: "change" }
        ],
        trainingTime: [
          {
            required: true,
            validator: rule.trainingTime,
            trigger: "change"
          }
        ],
        graduateSchool: [
          { required: true, validator: rule.school, trigger: "blur" }
        ],
        phone: [{ required: true, validator: rule.phone, trigger: "blur" }],
        idCard: [{ required: true, validator: rule.idCard, trigger: "blur" }],
        trainingCertificate: [
          {
            required: true,
            validator: rule.trainingCertificate,
            trigger: "blur"
          }
        ],
        postalAddress: [
          { required: true, validator: rule.address, trigger: "blur" }
        ]
      },
      tipDialogVisible: false
    };
  },
  watch: {
    formInfo(value) {
      if (value) {
        this.isShow = true;
        for (let item in value) {
          if (this.query.hasOwnProperty(item))
            this.$set(this.query, item, value[item]);
        }
        this.headImage = this.query.headImage;
        if (!this.query.projectNew) {
          this.isShow = false;
        }
        this.selectProject(this.query.projectFirst, false);
      }
    }
  },
  computed: {
    // 判断是否禁用表单组件输入
    isDisabled() {
      return this.operation === "watch" ? true : false;
    },
    isShowBtn() {
      if (this.formInfo) {
        if (this.formInfo.state === 4) {
          return true;
        }
        return this.operation === "watch" ? true : false;
      }
      return false;
    },
    // 草稿和驳回状态可修改
    disabledNormal() {
      
      if (this.operation === "watch") return true;
      if (this.formInfo && this.formInfo.name) {
        if (this.formInfo.state === 0 || this.formInfo.state === 4) {
          return false;
        } else {
          return true;
        }
      }
      return false;
    },
    nationList() {
      return registerData.nationList;
    },
    projectList() {
      this.otherProjectList = [
        ...registerData.sportsProjectList,
        ...registerData.sunshineProject
      ];
      return [
        ...registerData.sportsProjectList,
        ...registerData.sunshineProject
      ];
    }
  },
  methods: {
    // 关闭图片上传限制弹窗
    closeTips() {
      this.tipDialogVisible = false;
    },
    // 添加新增注册项目
    addNewProject() {
      this.isShow = true;
    },
    // 删除项目
    removeOtherProject() {
      this.isShow = false;
      this.$set(this.query, "projectNew", "");
    },
    // 选择首次注册项目，将其他项目对应选择项禁用,清空其他项目选项
    selectProject(value, isClear = true) {
      this.query.projectNew = isClear ? "" : this.query.projectNew;
      this.otherProjectList.filter(item => {
        if (item.value === value) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
    },
    // 表单提交验证
    submits() {
      return Promise.all([
        this.$refs["lefts"].validate(),
        this.$refs["rights"].validate()
      ])
        .then(res => {
          if (!this.query.headImage) {
            this.$message.warning("请上传2寸照片");
            return null;
          }
          return Promise.resolve(this.query);
        })
        .catch(err => {
          this.$message.warning("请完善教练员信息");
          return null;
        });
    },
    // 重置表单
    resetForm() {
      this.$refs["lefts"].resetFields();
      this.$refs["rights"].resetFields();
    },
    handleBefore(file) {
      this.files = file;
      this.loading = true;
      var testmsg = /^image\/(jpeg|png|jpg)$/.test(file.type);
      const isLt5M = file.size / 1024 / 1024 <= 1; //图片大小不超过2MB
      if (!testmsg) {
        this.$message.error("上传图片格式不对!");
        this.loading = false;
        return false;
      }
      if (!isLt5M) {
        // this.$message.error("上传图片大小不能超过 1M!");
        this.tipDialogVisible = true;
        this.loading = false;
        return false;
      }
      return testmsg && isLt5M;
    },
    // 上传成功
    uploadSuccess(response, file, fileList) {
      this.loading = false;
      this.$message.success("上传成功！");
      this.query.headImage = response.key;
      this.headImage = window.URL.createObjectURL(this.files);
    }
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
@media (min-width: 1920px) {
  .registration_form {
    /deep/ .address {
      width: 95%;
    }
  }
}

@media (min-width: 900px) and( max-width: 1919px) {
  .registration_form {
    /deep/ .address {
      width: 100%;
    }
  }
}
.registration_form {
  position: relative;
  display: flex;
  padding: 40px 20px 40px 0;
  justify-content: space-between;

  /deep/ .el-input,
  /deep/ .el-select {
    width: 100%;
  }
  /deep/ .el-input.is-disabled .el-input__inner {
    background-color: #fff;
    color: #606266;
  }
  .unit {
    color: #333;
    font-size: 14px;
    padding-right: 5px;
  }
  .user_img {
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .empty {
    width: 295px;
    height: 412px;
    background: #d8d8d8;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 40px;
    > p {
      margin-top: 10px;
      font-size: 14px;
    }
  }
}
</style>